var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 72,
    viewBox: "0 0 60 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7539_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4089 22.3107L58.4089 62.5331C58.4089 66.7451 55.4107 70.1855 51.6995 70.1855L8.29917 70.1855C4.6063 70.1855 1.58984 66.7659 1.58984 62.5331L1.58984 9.46618C1.58984 5.25419 4.58801 1.81369 8.29916 1.81369L39.524 1.81369L58.4089 22.3107Z",
    stroke: "#DB0011",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6959 23.041L41.9189 23.041C39.8531 23.041 38.1895 21.1435 38.1895 18.7873L38.1895 2.39809",
    stroke: "#DB0011",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7539_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 72,
    fill: "white",
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 72)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/default_icon.022f848fac2ac2bd175c208270ffccf8.svg";
export { ForwardRef as ReactComponent };